//
export default [
    {
        name: 'rut',
        props: {
            label: 'Rut',
        },
        flex: {
            sm6: true,
            lg3: true,
        },
        type: 'rut-field',
    },
    {
        name: 'business_name',
        props: {
            label: 'Razón social',
        },
        flex: {
            sm6: true,
            lg6: true,
        },
        type: 'text-field',
    },
    {
        name: 'is_pyme',
        props: {
            chips: true,
            items: [
                {
                    text: 'Si',
                    value: 1,
                },
                {
                    text: 'No',
                    value: 0,
                },
            ],
            label: 'Pyme',
            noObject: true,
        },
        type: 'select',
    },
]
